/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { updateField } from '../../services/item';
import { deepCloneArray } from '../../utils/array';
import { getId } from '../../utils/item';
import { ModalGlobal } from '../modal/modal.Global';
import { Checkbox } from '../form/checkbox';
import { BtnSimple } from '../form/btn.Simple';
import {
  buildSecondaryWidgetOptions,
  DEFAULT_LINK_DISPLAY_OPTIONS,
  LinkDisplayOptionsEditor,
  mergeLinkDisplayOptions,
} from './link.DisplayOptions';
import {
  WidgetSettingsRoot,
  WidgetSettingsCollapsibleSection,
} from '../form/settings.Widget';

export const LinkGlobalSettings = props => {
  const { linkId } = props;

  const link = useSelector(state => state.items?.[linkId]);
  const currentTab = useSelector(state => state.global.currentTab);
  const tab = useSelector(state => state.items?.[currentTab]);

  const [listToDisplay, setListToDisplay] = useState(
    deepCloneArray(DEFAULT_LINK_DISPLAY_OPTIONS)
  );
  const [init, setInit] = useState(false);
  const [noteEnabled, setNoteEnabled] = useState(false);
  const [noteNum, setNoteNum] = useState(0);
  const maskOptions = React.useMemo(() => {
    const options = [{ key: 'none', label: 'Aucun masque' }];
    (link?.pics || []).forEach((picObj, picIndex) => {
      const picId = getId(picObj);
      const payload = picObj?.[picId] || {};
      options.push({
        key: picIndex,
        label: payload?.label || `Image ${picIndex + 1}`,
        previewUrl: payload?.url || null,
        iconSlug: payload?.iconSlug || null,
      });
    });
    return options;
  }, [link?.pics]);
  const widgetOptions = React.useMemo(
    () => buildSecondaryWidgetOptions(link),
    [link],
  );

  useEffect(() => {
    if (tab?.grid?.length > 0) {
      if (tab.grid.find(element => element[linkId])) {
        const element = tab.grid.find(element => element[linkId]);
        if (element[linkId].elementsToDisplay) {
          const combinedList = mergeLinkDisplayOptions(
            listToDisplay,
            element[linkId].elementsToDisplay
          );
          setListToDisplay(combinedList);
        }
        setNoteEnabled(element?.[linkId]?.noteNumEnabled === true);
        setNoteNum(
          typeof element?.[linkId]?.noteNum === 'number'
            ? element[linkId].noteNum
            : 0
        );
        setInit(false);
      }
    }
  }, [tab]);

  // const [linkNums, setLinkNum] = useState([]);
  // useEffect(() => {
  //   const arr = link?.has_num.map(numObj => numObj[Object.keys(numObj)]);
  //   setLinkNum(arr);
  // }, [link]);

  useEffect(() => {
    if (init) {
      updateField(tab, tab?.type, listToDisplay, linkId, 'elementsToDisplay');
    } else {
      setInit(true);
    }
  }, [listToDisplay]);

  return (
    <ModalGlobal
      title={"Modification de l'affichage de " + link?.label}
      idToOpen={'link' + linkId}
    >
      <WidgetSettingsRoot>
        <WidgetSettingsCollapsibleSection
          title='Général'
          defaultOpen={true}
        >
          <LinkDisplayOptionsEditor
            listToDisplay={listToDisplay}
            setListToDisplay={setListToDisplay}
            maskOptions={maskOptions}
            widgetOptions={widgetOptions}
          />
        </WidgetSettingsCollapsibleSection>
        <WidgetSettingsCollapsibleSection title='Note' defaultOpen={false}>
          <Checkbox
            label="Activer une note (nombre) pour ce widget"
            value={noteEnabled}
            onChange={value => {
              setNoteEnabled(value);
              if (tab) {
                updateField(tab, tab?.type, value, linkId, 'noteNumEnabled');
              }
            }}
          />
          {noteEnabled && (
            <div className='mt-05 flex items-center gap-05'>
              <div className='text-sm text-contrast text-opacity-70 flex-1'>
                Quantité
              </div>
              <BtnSimple
                className='px-05'
                onClick={() => {
                  const next = Math.max(
                    0,
                    (Number.isFinite(noteNum) ? noteNum : 0) - 1
                  );
                  setNoteNum(next);
                  if (tab) {
                    updateField(tab, tab?.type, next, linkId, 'noteNum');
                  }
                }}
              >
                -
              </BtnSimple>
              <div className='min-w-px40 text-center text-contrast'>
                {Number.isFinite(noteNum) ? noteNum : 0}
              </div>
              <BtnSimple
                className='px-05'
                onClick={() => {
                  const next = Math.max(
                    0,
                    (Number.isFinite(noteNum) ? noteNum : 0) + 1
                  );
                  setNoteNum(next);
                  if (tab) {
                    updateField(tab, tab?.type, next, linkId, 'noteNum');
                  }
                }}
              >
                +
              </BtnSimple>
            </div>
          )}
        </WidgetSettingsCollapsibleSection>
      </WidgetSettingsRoot>
    </ModalGlobal>
  );
};
